export enum DataAmount {
  "10k" = "10000",
  "50k" = "50000",
  "100k" = "100000",
  "250k" = "250000",
  "500k" = "500000",
}

export enum DataLevel {
  "Single",
  "TwoLevel",
}

export interface GenerateDataFormModel {
  amount: DataAmount;
  level: DataLevel;
}

export interface UserModal {
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  phoneNo: string;
  country: string;
  partner: Partial<UserModal>;
}

export type UserData = Array<Partial<UserModal>>;

async function generateSingleUser(config: {
  level: DataLevel;
  partial: boolean;
}): Promise<Partial<UserModal>> {
  const Faker = await import("faker");

  const firstName = Faker.name.firstName();
  const lastName = Faker.name.lastName();

  let user: Partial<UserModal> = {};

  if (config.partial) {
    if (Math.random() < 0.5) {
      user.firstName = firstName;
    }

    if (Math.random() < 0.5) {
      user.lastName = lastName;
    }

    if (Math.random() < 0.5) {
      user.username = Faker.internet.userName(firstName, lastName);
    }

    if (Math.random() < 0.5) {
      user.email = Faker.internet.email(firstName, lastName);
    }

    if (Math.random() < 0.5) {
      user.phoneNo = Faker.phone.phoneNumber();
    }

    if (Math.random() < 0.5) {
      user.country = Faker.address.county();
    }
  } else {
    user = {
      firstName,
      lastName,
      username: Faker.internet.userName(firstName, lastName),
      email: Faker.internet.email(firstName, lastName),
      phoneNo: Faker.phone.phoneNumber(),
      country: Faker.address.county(),
    };
  }

  if (config.level === DataLevel.TwoLevel) {
    user.partner = await generateSingleUser({
      level: DataLevel.Single,
      partial: config.partial,
    });
  }

  if (Object.keys(user).length === 0) {
    return generateSingleUser(config);
  }

  return user;
}

export async function generateUsers(
  config: GenerateDataFormModel,
): Promise<UserData> {
  const { level } = config;
  let users: UserData = [];
  const amount = Number(config.amount);
  for (let count = 0; count < amount; count++) {
    if (count === 0) {
      users.push(await generateSingleUser({ level, partial: false }));
      continue;
    }

    users.push(await generateSingleUser({ level, partial: true }));
  }
  return users;
}
